import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
var VeltRecorderControlPanelActionBarStopWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-stop-wireframe", __assign({}, transformedProps), children));
};
export default VeltRecorderControlPanelActionBarStopWireframe;
